import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationMessagesComponent } from './components/notification-messages/notification-messages.component';
import { NotificationMessagesService } from './services/notification-messages.service';

@NgModule({
  declarations: [NotificationMessagesComponent],
  imports: [CommonModule],
  exports: [NotificationMessagesComponent],
  providers: [NotificationMessagesService],
})
export class NotificationMessagesModule { }
